var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "func-modal",
    {
      ref: "modal",
      attrs: { title: "Refund Request Rejection" },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function(props) {
            return [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  class: [{ disabled: _vm.processing }],
                  attrs: { disabled: _vm.processing },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.submit()
                    }
                  }
                },
                [
                  _vm.processing
                    ? _c("i", { staticClass: "fa fa-spin fa-spinner" })
                    : _vm._e(),
                  _vm._v("\n            Submit\n        ")
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-link",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return props.close()
                    }
                  }
                },
                [_vm._v("Close")]
              )
            ]
          }
        }
      ])
    },
    [
      _c("template", { slot: "body" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", { attrs: { for: "rejectReason" } }, [
              _vm._v("Reject reason")
            ]),
            _vm._v(" "),
            _c("vue-html5-editor", {
              ref: "commentEditor",
              attrs: { height: 100, content: _vm.reject_reason },
              on: {
                change: function(x) {
                  return (_vm.reject_reason = x)
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.reject_reason
              ? _c("div", { staticClass: "text-danger" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.errors.reject_reason[0]) +
                      "\n            "
                  )
                ])
              : _vm._e()
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35542f62", { render: render, staticRenderFns: staticRenderFns })
  }
}